import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { dismissErrors } from '../actions/errorActions'
import ErrorModal from '../components/ErrorModal'

const ErrorModalContainer = ({ errorState, dismissErrors }) => {
  const firstUndismissedError = errorState.errors.find(error => !error.dismissed && !error.ignorable)
  return (<ErrorModal error={firstUndismissedError} dismissErrors={dismissErrors} />)
}

const mapStateToProps = (state) => ({
  errorState: state.errorState
})

const mapDispatchToProps = (dispatch) => bindActionCreators({
  dismissErrors
}, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(ErrorModalContainer)
